React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
ModelLoader = require 'app/scripts/db/model-loader'
PluginHeaderButtonsView = require 'app/scripts/views/plugin/plugin-header-buttons-view'
Controller = require 'app/scripts/controller'
Dialog = require 'app/scripts/views/lib/dialog'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
WindowSize = require 'app/scripts/lib/window-size'
DirectoryView = require 'app/scripts/views/directory/directory-view'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
{ boardViewViewLoaders } = require './board-view-view-loaders'
GoogleMapsApi = require 'app/scripts/lib/google-maps-api'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ CalendarBoardButton } = require 'app/scripts/views/board/calendar-board-button'

BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
CALENDAR_POWER_UP_ID = LegacyPowerUps.calendar

module.exports.reloadCustomFields = ->
  if @model.isPluginEnabled(CUSTOM_FIELDS_ID)
    # we need to give the server a second to prevent any race conditions
    # mainly if we were the ones to enable custom fields
    setTimeout =>
      ModelLoader.loadCustomFields(@model.id)
    , 1000

module.exports.renderPluginButtons = ->
  if @pluginHeaderButtonsView?
    @pluginHeaderButtonsView.requestButtonsDebounced()
  else
    @pluginHeaderButtonsView = @subview PluginHeaderButtonsView, @model
  @appendSubview @pluginHeaderButtonsView, @$('.js-plugin-header-btns')

  @

module.exports.renderBoardHeaderCalendar = (options = {}) ->
  container = @$('.js-calendar-board-btn')
  if !container.length
    return

  isCalendarEnabled = @model.isPowerUpEnabled('calendar')
  container.toggleClass('hide', !isCalendarEnabled)
  if isCalendarEnabled
    renderComponent(React.createElement(CalendarBoardButton, {
      idBoard: @model.id
      backgroundBrightness: @model.get('prefs').backgroundBrightness
      showAutoEnablePopover: options.showAutoEnablePopover
      dateAutoEnabled: options.dateAutoEnabled
      onClick: => @toggleCalendar()
      onDisableCalendarClick: => @model.disablePlugin(CALENDAR_POWER_UP_ID)
      onOpenDirectoryClick: => @toggleDirectory()
      onAutoEnablePopoverShown: => @model.setPluginDataByKey(
        CALENDAR_POWER_UP_ID,
        'board',
        'private',
        'seenPopover',
        true
      )
      countDueDates: => @model.countDueDates()
    }), container[0])


module.exports.navigateToBoard = ->
  boardUrl = Controller.getBoardUrl(@model.id)
  Controller.navigate boardUrl, { trigger: true }

module.exports.closeDetailView = ->
  Dialog.hide(true)
  @closeCalendar(false)
  @closeDirectory(false)
  @closeMap(false)
  @closeButler(false)
  return

module.exports.clickCloseDirectory = ->
  if @directoryView
    Analytics.sendUIEvent
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'boardDirectoryCloseButton',
      attributes:
        boardId: @model.id
        organizationId: @model.get('idOrganization')
      source: @directoryView.activeEventSource()

  @toggleDirectory()

module.exports.toggleDirectory = ->
  if @directoryView
    if @directoryReturnCard
      @closeDirectory(false)
      Controller.showCardDetail @directoryReturnCard
      @directoryReturnCard = null
    else
      @navigateToBoard()
  else
    @navigateToDirectory()

module.exports.navigateToDirectory = (returnCard) ->
  directoryUrl = Controller.getBoardUrl(@model.id, 'power-ups')
  Controller.navigate directoryUrl, { trigger: true }

  @directoryReturnCard = returnCard

  # Close the sidebar menu for window sizes that aren't extra large.
  if !WindowSize.fExtraLarge
    @sidebarView.hideSidebar()

module.exports.showDirectory = (section, category, idPlugin, isEnabling) ->
  @$('#board').addClass('hide')

  @directoryView = new DirectoryView({
    @model,
    @modelCache,
    section,
    category,
    idPlugin,
    isEnabling,
    boardView: @
  })
  @$('.board-canvas').append(@directoryView.render().el)

module.exports.closeDirectory = (navigateToBoard = true) ->
  if @directoryView?
    @directoryView.remove()
    @directoryView = null
    if navigateToBoard
      @navigateToBoard()
    @$('#board').removeClass('hide')
    @$('.js-list-name-input').trigger('autosize.resize', false)
  return

module.exports.toggleCalendar = ->
  sendPluginUIEvent({
    idPlugin: LegacyPowerUps.calendar
    idBoard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'powerUpBoardButton'
      source: 'boardScreen'
  })

  if @calendarView
    if @calendarReturnCard
      @closeCalendar(false)
      Controller.showCardDetail @calendarReturnCard
      @calendarReturnCard = null
    else
      @navigateToBoardEvent()
  else
    @navigateToCalendarEvent()

module.exports.navigateToCalendarEvent = ->
  track("Board Header", "Open Calendar View via Header")
  trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', LegacyPowerUps.calendar)
  @navigateToCalendar()

module.exports.navigateToCalendar = (returnCard) ->
  @calendarReturnCard = returnCard
  calendarBoardUrl = Controller.getBoardUrl(@model.id, 'calendar')
  Controller.navigate calendarBoardUrl, { trigger: true }

module.exports.navigateToBoardEvent = ->
  @navigateToBoard()

module.exports.isShowingCalendar = -> @calendarView?

module.exports.showCalendar = (date) ->
  if !@model.isPowerUpEnabled('calendar') || @isShowingCalendar()
    return

  @$('.calendar-btn').addClass('board-header-btn-enabled')
  @$('#board').addClass('hide')

  boardViewViewLoaders.loadCalendarControllerView()
  .then (CalendarControllerView) =>
    @calendarView = new CalendarControllerView({ @model, @modelCache })
    @$('.board-canvas').append(@calendarView.render(date).el)
    @calendarView.addedToDOM()

    onBoardButton = featureFlagClient.get('ecosystem.auto-enable-calendar-popover', 'none') == 'onBoardButton'
    if onBoardButton && @model.editable()
      # check if we've auto-enabled the calendar
      dateAutoEnabled = @model.getPluginDataByKey(
        CALENDAR_POWER_UP_ID,
        'board',
        'shared',
        'dateAutoEnabled',
        null
      )
      # check if this user has seen the popover yet
      seenPopover = @model.getPluginDataByKey(
        CALENDAR_POWER_UP_ID,
        'board',
        'private',
        'seenPopover',
        false
      )
      @renderBoardHeaderCalendar({
        showAutoEnablePopover: dateAutoEnabled && !seenPopover
        dateAutoEnabled: dateAutoEnabled
      })

module.exports.closeCalendar = (navigateToBoard = true) ->
  if @calendarView?
    @calendarView.remove()
    @calendarView = null
    if navigateToBoard
      @navigateToBoard()
    @$('.calendar-btn').removeClass('board-header-btn-enabled')
    @$('#board').removeClass('hide')

    # Hack to resolve a bug where the lists won't have been
    # sized properly if the calendar was visible on initial
    # render (and the board and it's lists were hidden)
    @$('.js-list-name-input').trigger('autosize.resize', false)
  return

module.exports.toggleMap = ->
  sendPluginUIEvent({
    idPlugin: MAP_POWER_UP_ID
    idBoard: @model.id
    event:
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'powerUpBoardButton'
      source: 'boardScreen'
  })
  if @mapView
    if @mapReturnCard
      @closeMap(false)
      Controller.showCardDetail @mapReturnCard
      @mapReturnCard = null
    else
      @navigateToBoardEvent()
  else
    @navigateToMapEvent()

module.exports.navigateToMapEvent = ->
  trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', MAP_POWER_UP_ID)
  trackUe(Noun.BOARD, Verb.OPENS, Noun.BOARD_MAP, '', '', 'by clicking the map button', {
    idBoard: @model.id
  })
  @navigateToMap()

module.exports.navigateToMap = (centerTo, returnCard) ->
  @mapCenterTo = centerTo
  @mapReturnCard = returnCard
  mapBoardUrl = Controller.getBoardUrl(@model.id, 'map')
  Controller.navigate mapBoardUrl, { trigger: true }

module.exports.showMap = ->
  if !@model.isMapPowerUpEnabled() || @mapView?
    return

  @$('.js-map-btn').addClass('board-header-btn-enabled')
  @$('#board').addClass('hide')

  boardViewViewLoaders.loadMapView()
  .then (MapView) =>
    @mapView = new MapView({ @model, @modelCache, @mapCenterTo })
    @$('.board-canvas').append(@mapView.render().el)

module.exports.closeMap = (navigateToBoard = true) ->
  if @mapView?
    @mapView.remove()
    @mapView = null
    if navigateToBoard
      @navigateToBoard()
    @$('.js-map-btn').removeClass('board-header-btn-enabled')
    @$('#board').removeClass('hide')
    @$('.js-list-name-input').trigger('autosize.resize', false)
  return

module.exports.renderBoardHeaderMap = ->
  if @model.isMapPowerUpEnabled()
    GoogleMapsApi.load()
      .then =>
        @$('.js-map-btn').removeClass('hide')
  else
    @$('.js-map-btn').addClass('hide')
  @

module.exports.toggleButler = (url) ->
  if @butlerView || !url?
    @navigateToBoardEvent()
  else
    @butlerUrl = url
    @navigateToButler(url)

module.exports.navigateToButler = ->
  butlerBoardUrl = Controller.getBoardUrl(@model.id, 'butler')
  Controller.navigate(butlerBoardUrl, { trigger: true })

module.exports.showButler = ->
  if @butlerView?
    return
  if !@model.editable()
    @navigateToBoardEvent()
    return
  # this codepath is hit if user goes directly to the /butler route by
  # typing it in the address bar or refreshing while already on it.
  if !@butlerUrl?
    @$('#board').addClass('hide')
    PluginRunner.one
      plugin: BUTLER_POWER_UP_ID
      command: 'show-settings'
      board: @model
    # the Controller no-op's the navigation to the /butler route because
    # we're already on it. But by this time Butler has loaded and provided
    # us its url. So we can finish the job ourselves by calling showButler().
    .then => @showButler()
    return

  @$('#board').addClass('hide')

  boardViewViewLoaders.loadButlerView()
  .then (ButlerView) =>
    @butlerView = new ButlerView({ @butlerUrl })
    @$('.board-canvas').append(@butlerView.render().el)

module.exports.closeButler = (navigateToBoard = true) ->
  if @butlerView?
    @butlerView.remove()
    @butlerView = null
    if navigateToBoard
      @navigateToBoard()
    @$('#board').removeClass('hide')
    @$('.js-list-name-input').trigger('autosize.resize', false)
  return
